import "../index.css";
import { Card, CardContent, Skeleton } from "@/ui-kit";

export const SectionSkeleton = () => {
  return (
    <Card className="profile-card" variant="layer1">
      <CardContent>
        <div className="profile-card__layout">
          <Skeleton width="8.75rem" height="8.75rem" className="shrink-0" />
          <div className="profile-card__details">
            <Skeleton width="13.75rem" height="2rem" />
            <div className="profile-card__section">
              <Skeleton width="18.75rem" height="1.5rem" />
              <Skeleton width="18.75rem" height="1.5rem" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
